<template>
  <div>
    <!-- <div style="margin-bottom: 10px; ">
      Frequency and bases covered by repeats
    </div> -->
    <el-table :data="tableData" :max-height="405" stripe border :header-cell-style="headerStyle">
      <el-table-column prop="name" label="Repeat Class"></el-table-column>
      <el-table-column prop="value" label="Frequency" sortable></el-table-column>
      <el-table-column prop="bases" label="Bases" sortable></el-table-column>
      <el-table-column v-if="info.OrgInfo.Annotation === 'Y'" prop="exon" label="Exon" sortable></el-table-column>
      <el-table-column v-if="info.OrgInfo.Annotation === 'Y'" prop="intron" label="Intron" sortable></el-table-column>
      <el-table-column v-if="info.OrgInfo.Annotation === 'Y'" prop="intergenic" label="Intergenic" sortable></el-table-column>
      <el-table-column v-if="info.OrgInfo.Annotation === 'Y'" prop="promoter" label="Promoter" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { repeatAnnoDist, repeatFrequency } from '../scripts/utils.js'

export default {
  name: 'TableRepeatFrequency',
  props: {
    info: {
      type: Object
    }
  },
  data () {
    return {
      headerStyle: {
        "background-color": "#EEF1F6",
        "color": "#324157",
        "font-weight": "bold",
        "font-size": "1.1em",
        "border": "1px solid #dcdcdc"
      }
    }
  },
  computed: {
    tableData () {
      const freq = repeatFrequency(this.info.RepInfo.PlotData, 501)
      const bases = repeatFrequency(this.info.RepInfo.PlotData, 501, 'kmer', 'bases')
      freq.map((f, i) => {
        f.bases = bases[i].value
      })
      if (this.info.OrgInfo.Annotation === 'Y') {
        const repeats = _.map(freq, 'name');
        const plotdata = this.info.AnnoInfo.RepAnno;
        const annodata = repeatAnnoDist(plotdata, repeats, true);
        freq.map((f, i) => {
          if (f.value > 0) {
            f.exon = annodata[f.name]['Exon']
            f.intron = annodata[f.name]['Intron']
            f.intergenic = annodata[f.name]['Intergenic']
            f.promoter = annodata[f.name]['Promoter']
          }
          else {
            f.exon = 0
            f.intron = 0
            f.intergenic = 0
            f.promoter = 0
          }
        })
      }
      return freq
    }
  }
}
</script>
